import { defineStore } from 'pinia'
import api from '@/services/api.core'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    tenant: null,
    permissions: [],
    roles: [],
    loading: false,
    error: null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.user,
    fullName: (state) => state.user?.name || '',
    isSystemAdmin: (state) => state.roles.includes('system_admin'),
    isFinanceAdmin: (state) => state.roles.includes('finance_admin'),
  },

  actions: {
    async login(email, password) {
      this.loading = true
      this.error = null
      try {
        const { data } = await api.post('/auth/login', { email, password })
        localStorage.setItem('va_token', data.token)
        localStorage.setItem('refresh_token', data.refresh_token)
        this.user = data.user
        this.tenant = data.tenant
        this.permissions = data.user?.permissions || []
        this.roles = data.user?.role ? [data.user.role] : []
        return true
      } catch (err) {
        this.error = err.response?.data?.message || 'Login failed'
        return false
      } finally {
        this.loading = false
      }
    },

    async fetchUser() {
      this.loading = true
      try {
        const { data } = await api.get('/user')
        this.user = data.user
        this.tenant = data.tenant
        this.permissions = data.user?.permissions || []
        this.roles = data.user?.role ? [data.user.role] : []
      } catch (err) {
        localStorage.removeItem('va_token')
        this.user = null
        this.tenant = null
        this.permissions = []
        this.roles = []
        throw err
      } finally {
        this.loading = false
      }
    },

    logout() {
      localStorage.removeItem('va_token')
      this.user = null
      this.tenant = null
      this.permissions = []
      this.roles = []
    },

    hasPermission(permission) {
      if (this.isSystemAdmin) return true
      return this.permissions.includes(permission)
    },
  },
})
